module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 pa3"
  }, [_c('div', {
    staticClass: "tc pl-title mb3"
  }, [_vm._v("Data visualizations")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Got it!\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mh3 pa3 flex-grow"
  }, [_c('div', {
    staticClass: "flex justify-center mb2"
  }, [_c('img', {
    staticClass: "ma3",
    attrs: {
      "src": "/static/pieChartColour.svg",
      "alt": "chord-diagram"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ma3",
    attrs: {
      "src": "/static/cloudColour.svg",
      "alt": "word-cloud"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pl-subheading tc"
  }, [_vm._v("\n      Click on these icons to see data visualizations that show your students\n      ideas and engagement from the RoundTable.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-60ccabdc!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/pages/onlineWalkthroughShareableGraphics.vue
// module id = 1326
// module chunks = 61